import React from "react";

import useMediaQuery from "@mui/material/useMediaQuery";

import Table from "./Table";
import MobileList from "./MobileList";
import EmptyState from "./EmptyState";
import MobileCard from "./MobileCard";

import { DataTableProps, DataTableColumn } from "./types";

const MOBILE_BREAKPOINT = "(max-width: 1040px)";

const DataTable = <T extends { id: string }>(props: DataTableProps<T>) => {
  const {
    columns,
    rows,
    loading = false,
    actions,
    emptyMessage,
    emptyIcon,
    mobileBreakpoint = MOBILE_BREAKPOINT,
    mobileRenderer,
    skeletonRowCount,
  } = props;

  const isMobile = useMediaQuery(mobileBreakpoint);

  if (!loading && !!rows && rows.length <= 0) {
    return <EmptyState message={emptyMessage} icon={emptyIcon} />;
  }

  if (isMobile) {
    return (
      <MobileList<T>
        rows={rows || []}
        columns={columns}
        actions={actions}
        loading={loading}
        mobileRenderer={mobileRenderer}
        skeletonRowCount={skeletonRowCount}
      />
    );
  }

  return (
    <Table<T>
      columns={columns}
      rows={rows || []}
      actions={actions}
      loading={loading}
      skeletonRowCount={skeletonRowCount}
    />
  );
};

export default DataTable;
export { MobileCard };
export type { DataTableColumn, DataTableProps };
